import React from "react"

import V2ChromeLayout from "@utils/v2ChromeLayout"
import Capital from "@organisms/capital/capital"

// Same shape as src/pages/affiliates.js: V2ChromeLayout supplies nav, footer and head tags,
// and <Capital /> is the whole body.
//
// Live since the Stripe Capital launch (4 Nov 2026), but unlisted: no nav link, and `robots`
// below keeps it noindex, nofollow. People reach it from the app's Capital components and the
// launch email.
const CapitalPage = () => (
  <V2ChromeLayout
    title="MoonClerk Capital — Fast funding for your business | MoonClerk"
    description="Quick access to funds to help grow your business–without the hassle of traditional loans. Check your eligibility for MoonClerk Capital in your MoonClerk dashboard."
    canonicalPath="/capital"
    robots="noindex, nofollow"
    legacyTypography={false}
  >
    <Capital />
  </V2ChromeLayout>
)

export default CapitalPage
